var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order" }, [
    _c("h2", { staticClass: "caption caption--size_2" }, [
      _vm._v(_vm._s(_vm._("Order Creation. Responce")))
    ]),
    _c("div", { staticClass: "order__content" }, [
      _c("div", { staticClass: "copy" }, [
        _c("div", { staticClass: "copy__field" }, [
          _c("p", { staticClass: "copy__content" }, [
            _vm._v(_vm._s(_vm.orderLink))
          ])
        ]),
        _c(
          "div",
          {
            ref: "copyButton",
            staticClass: "copy__button",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.copyOrderLink($event)
              }
            }
          },
          [_c("i", { staticClass: "icon icon--type_copy" })]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-616f8b72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-616f8b72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Order/OrderResponse.vue
// module id = 969
// module chunks = 0